import React from 'react';
import { Container } from 'react-bootstrap';
import AppHeader from '../../components/Common/AppHeader';
import AppFooter from '../../components/Common/AppFooter';

const PrivacyPolicy = () => (
  <div className="bg-light min-vh-100 d-flex flex-column">
    <AppHeader />
    <Container className="py-5 flex-grow-1 bg-white shadow-sm my-5 rounded p-5">
      <h2 className="fw-bold text-dark">Privacy Policy</h2>
      <p className="text-muted">Effective Date: 31 March 2026</p>
      <hr />

      <section className="mb-4">
        <h4 className="fw-bold">1. Introduction</h4>
        <p>
          This Privacy Policy explains how AcademicOS (BrahmaGPT Platform) collects, processes, stores, and protects data
          in connection with its AI-powered curriculum, content, and assessment generation services.
        </p>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">2. Who We Are</h4>
        <p>
          AcademicOS is operated by TatvaOne Labs FZCO (UAE) and JNANA AI LABS PRIVATE LIMITED (India).
          Depending on usage, AcademicOS may act as a Data Controller, Data Processor, or Joint Controller.
        </p>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">3. User Categories & Data Roles</h4>
        <ul>
          <li><strong>Institutions:</strong> AcademicOS acts as Data Processor</li>
          <li><strong>Independent Users (SMEs):</strong> AcademicOS acts as Controller or Joint Controller</li>
          <li><strong>Enterprise Partners:</strong> Role depends on contractual agreement</li>
        </ul>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">4. What Data We Process</h4>
        <ul>
          <li><strong>Institutional Data:</strong> Curriculum structures, project metadata</li>
          <li><strong>User Data:</strong> Name, email, role, login activity</li>
          <li><strong>Content Data:</strong> Uploaded materials, generated outputs</li>
          <li><strong>AI Processing Data:</strong> Prompts, context, token usage</li>
          <li><strong>Technical Data:</strong> Logs, IP, device information</li>
        </ul>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">5. Purpose of Processing</h4>
        <ul>
          <li>Curriculum and content generation</li>
          <li>Assessment and teaching material creation</li>
          <li>Platform security and monitoring</li>
          <li>Billing and usage tracking</li>
        </ul>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">6. AI Processing & Infrastructure</h4>
        <p>
          AcademicOS uses secure cloud AI services (e.g., Google Vertex AI). Data is processed in isolated environments
          and is not used to train public AI models.
        </p>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">7. Intellectual Property & Content Responsibility</h4>
        <p>
          Users retain ownership of uploaded content and are responsible for ensuring compliance with copyright laws.
          AcademicOS does not verify ownership or licensing.
        </p>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">8. AI Output Disclaimer</h4>
        <p>
          AI-generated outputs are probabilistic and may contain inaccuracies. Users must validate outputs before use.
        </p>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">9. Data Retention & Deletion</h4>
        <p>
          Data is retained based on project lifecycle and legal requirements. Temporary AI caches expire automatically.
        </p>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">10. Access Control</h4>
        <p>
          Access is governed by role-based access control (RBAC) with audit logging and least privilege principles.
        </p>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">11. Data Sharing</h4>
        <p>
          AcademicOS does not sell data. Subprocessors (e.g., cloud providers) are used under strict contractual safeguards.
        </p>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">12. Security Measures</h4>
        <ul>
          <li>Encryption in transit (TLS/HTTPS)</li>
          <li>Encryption at rest (where applicable)</li>
          <li>Tenant-level data isolation</li>
          <li>Monitoring and incident response</li>
        </ul>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">13. User Rights</h4>
        <p>
          Users may request access, correction, or deletion of personal data, subject to applicable laws.
        </p>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">14. Children / Students</h4>
        <p>
          Institutions are responsible for lawful collection of student data. AcademicOS processes such data only under
          institutional instructions.
        </p>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">15. Contact</h4>
        <p>Email: info@tatvaone.ai</p>
      </section>

      <section className="mb-4">
        <h4 className="fw-bold">16. Updates</h4>
        <p>
          This Privacy Policy may be updated periodically. Continued use of the Platform constitutes acceptance of updates.
        </p>
      </section>

    </Container>
    <AppFooter />
  </div>
);

export default PrivacyPolicy;
